import { keyframes } from "@mui/system";
import styled from "styled-components";

/* animation */
export const toastSlideIn = keyframes({
  from: {
    opacity: 0,
    transform: "translateX(20px)",
  },
  to: {
    opacity: 1,
    transform: "translateX(0)",
  },
});

export const toastSlideOut = keyframes({
  from: {
    opacity: 1,
    transform: "translateX(0)",
  },
  to: {
    opacity: 0,
    transform: "translateX(20px)",
  },
});

/* Toast */
export const ToastWrapper = styled("div")(() => ({
  position: "fixed",
  top: 60,
  right: 20,
  zIndex: 9999,
  display: "flex",
  flexDirection: "column",
  gap: 12,
}));

export const ToastItem = styled("div")<{
  type?: "success" | "error" | "info";
}>(({ type = "info" }) => ({
  minWidth: 280,
  display: "flex",
  padding: "14px 16px",
  borderRadius: 12,
  color: "#fff",
  fontSize: 14,
  fontWeight: 500,

  backgroundColor:
    type === "success"
      ? "#16a34a"
      : type === "error"
      ? "#dc2626"
      : "rgb(248, 81, 31)",

  boxShadow: "0 10px 25px rgba(0,0,0,.2)",
  animation: `${toastSlideIn} 0.25s ease-out`,
}));
